import { collection, getDocs } from 'firebase/firestore/lite';
import React, { useEffect, useState } from 'react'
import { db } from '../../firebase.config';
import LoadingAdmin from '../extra/LoadingAdmin';

function AllOrders() {
    const [orders,setOrders] = useState([])
    useEffect(()=>{

        const getAllOrders = async () => {
          const ordersData = [];

          // Get all user documents
          const usersRef = collection(db, "users");
          const usersSnapshot = await getDocs(usersRef);
          
          // Loop through each user document
          for (const userDoc of usersSnapshot.docs) {
            // Get the orders subcollection of the current user
            const ordersRef = collection(userDoc.ref, "orders");
            const ordersSnapshot = await getDocs(ordersRef);
            
            // Loop through each order document and add it to the ordersData array
            for (const orderDoc of ordersSnapshot.docs) {
              ordersData.push({
                userId: userDoc.id,
                address: userDoc.data().address,
                userName:userDoc.data().name,
                userMail: userDoc.data().email,
                orderId: orderDoc.id,
                orderData: orderDoc.data(),
              });
            }
          }

          console.log("ordata: ", ordersData);
          setOrders(ordersData);
          return ordersData;
        };



        getAllOrders()

    },[])

    
    
  return (
    <div>
      {orders.length === 0 ? (
        <LoadingAdmin/>
      ) : (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="p-4">
                  <div className="flex items-center">0</div>
                </th>
                <th scope="col" className="px-6 py-3 max-w-6">
                  User
                </th>
                <th scope="col" className="px-6 py-3">
                  Time
                </th>

                <th scope="col" className="px-6 py-3">
                  Payment
                </th>
                <th scope="col" className="px-6 py-3">
                  TotalPi
                </th>

                <th scope="col" className="px-6 py-3 max-w-10">
                  Items
                </th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                  key={index+1}
                >
                  <td className="w-4 p-4">
                    <div className="flex items-center">
                      <p>{index + 1}</p>
                      {/* <input id="checkbox-table-search-1" type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                        <label for="checkbox-table-search-1" className="sr-only">checkbox</label> */}
                    </div>
                  </td>
                  <td
                    className="px-6 py-4 text-gray-900  dark:text-slate-200"
                  >
                    <span className="font-medium tracking-wider">
                      {order.userName}
                    </span>{" "}
                    <br />
                    <span className="font-normal text-slate-400">
                      {order.userMail}
                    </span>{" "}
                    <br />
                    <span className="font-normal text-slate-500">
                      {order.address
                        ? `  ${order.address.house}, ${order.address.landmark}, ${order.address.street}, ${order.address.city}, ${order.address.state} ${order.address.pin}`
                        : "Unavailable"}
                    </span>
                  </td>

                  <td className="px-6 py-4">
                    {order.orderData.server
                      ? order.orderData.server.toDate().toLocaleString()
                      : "N/A"}
                  </td>
                  {order.orderData.payment ? (
                    <td className="px-6 py-4 text-emerald-500">Done</td>
                  ) : (
                    <td className="px-6 py-4 text-rose-500">Failed</td>
                  )}
                  <td className="px-6 py-4 font-semibold">
                    {order.orderData.total}
                    <span className="font-normal">&pi;</span>{" "}
                  </td>
                  <td className="px-6 py-4 w-4">
                    {order.orderData.items.map((items, pn) => (
                      <p>
                        <span className='max-w-4'> {pn + 1}.&nbsp;{items.title} </span> &#40; QTY: {items.quantity}{" "}
                        &#41; <br />
                      </p>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AllOrders